import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import {
  getWarehousesDepositList as getWarehousesDepositListApi,
  getWarehousesWithdrawList as getWarehousesWithdrawListApi,
  getWarehouses as getWarehousesApi,
  addNewWarehouse as addNewWarehouseApi,
  updateWarehouse as updateWarehouseApi,
  deleteWarehouse as deleteWarehouseApi,
  getWarehousesCompanies as getWarehousesCompaniesApi,
  getWarehousesWithdraw as getWarehousesWithdrawApi,
  addNewWarehouseWithdraw as addNewWarehouseWithdrawApi,
  updateWarehouseWithdraw as updateWarehouseWithdrawApi,
  deleteWarehouseWithdraw as deleteWarehouseWithdrawApi,
  getWarehousesReportSummary as getWarehousesReportSummaryApi,
  getWarehousesReportInvoice as getWarehousesReportInvoiceApi,
  getWarehousesInvoices as getWarehousesInvoicesApi,
  addNewWarehousesInvoice as addNewWarehousesInvoiceApi,
  updateWarehousesInvoice as updateWarehousesInvoiceApi,
  deleteWarehousesInvoice as deleteWarehousesInvoiceApi,
  getWarehousesInvoiceByNumber as getWarehousesInvoiceByNumberApi,
} from "../../helpers/realbackend_helper";

export const getWarehousesDepositList = createAsyncThunk(
  "warehouse/getWarehousesDepositList",
  async (filters, thunkAPI) => {
    try {
      const response = await getWarehousesDepositListApi(filters);
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response || error.message);
    }
  }
);

export const getWarehousesWithdrawList = createAsyncThunk(
  "warehouse/getWarehousesWithdrawList",
  async (filters, thunkAPI) => {
    try {
      const response = await getWarehousesWithdrawListApi(filters);
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response || error.message);
    }
  }
);

export const getWarehouses = createAsyncThunk(
  "warehouse/getWarehouses",
  async (filters, thunkAPI) => {
    try {
      const response = await getWarehousesApi(filters);
      return response;
    } catch (error) {
      console.error("Error fetching warehouse:", error);
      return thunkAPI.rejectWithValue(
        error.response || error.message || "Error fetching warehouse"
      );
    }
  }
);

export const addNewWarehouse = createAsyncThunk(
  "warehouse/addNewWarehouse",
  async (warehouse) => {
    try {
      const response = addNewWarehouseApi(warehouse);
      toast.success("Орлого амжилттай нэмэгдлээ", {
        autoClose: 3000,
      });
      return response;
    } catch (error) {
      toast.error("Орлого бүртгэхэд алдаа гарлаа!", {
        autoClose: 3000,
      });
      return error;
    }
  }
);

export const updateWarehouse = createAsyncThunk(
  "warehouse/updateWarehouse",
  async (warehouse) => {
    try {
      const response = updateWarehouseApi(warehouse);
      toast.success("Мэдээллийг амжилттай засварлалаа", {
        autoClose: 3000,
      });
      return response;
    } catch (error) {
      toast.error("Мэдээллийг засварлахад алдаа гарлаа!", {
        autoClose: 3000,
      });
      return error;
    }
  }
);

export const deleteWarehouse = createAsyncThunk(
  "warehouse/deleteWarehouse",
  async (id, { rejectWithValue }) => {
    try {
      await deleteWarehouseApi(id);

      toast.success("Мэдээллийг амжилттай устгалаа", {
        autoClose: 3000,
      });

      return { id };
    } catch (error) {
      toast.error("Мэдээллийг устгахад алдаа гарлаа!", {
        autoClose: 3000,
      });

      return rejectWithValue({
        error: error.response?.data?.message || error.message,
      });
    }
  }
);

export const getWarehousesCompanies = createAsyncThunk(
  "warehouse/getWarehousesCompanies",
  async (_, thunkAPI) => {
    try {
      const response = await getWarehousesCompaniesApi();
      return response;
    } catch (error) {
      console.error("Error fetching warehouse:", error);
      return thunkAPI.rejectWithValue(
        error.response || error.message || "Error fetching warehouse"
      );
    }
  }
);

export const getWarehousesWithdraw = createAsyncThunk(
  "warehouse/getWarehousesWithdraw",
  async (filters, thunkAPI) => {
    try {
      const response = await getWarehousesWithdrawApi(filters);
      return response;
    } catch (error) {
      console.error("Error fetching warehouse:", error);
      return thunkAPI.rejectWithValue(
        error.response || error.message || "Error fetching warehouse"
      );
    }
  }
);

export const addNewWarehouseWithdraw = createAsyncThunk(
  "warehouse/addNewWarehouseWithdraw",
  async (warehouse) => {
    try {
      const response = addNewWarehouseWithdrawApi(warehouse);
      toast.success("Зарлага амжилттай хийгдлээ", {
        autoClose: 3000,
      });
      return response;
    } catch (error) {
      toast.error("Зарлага гаргахад алдаа гарлаа!", {
        autoClose: 3000,
      });
      return error;
    }
  }
);

export const updateWarehouseWithdraw = createAsyncThunk(
  "warehouse/updateWarehouseWithdraw",
  async (warehouse) => {
    try {
      const response = updateWarehouseWithdrawApi(warehouse);
      toast.success("Мэдээллийг амжилттай засварлалаа", {
        autoClose: 3000,
      });
      return response;
    } catch (error) {
      toast.error("Мэдээллийг засварлахад алдаа гарлаа!", {
        autoClose: 3000,
      });
      return error;
    }
  }
);

export const deleteWarehouseWithdraw = createAsyncThunk(
  "warehouse/deleteWarehouseWithdraw",
  async (id, { rejectWithValue }) => {
    try {
      await deleteWarehouseWithdrawApi(id);

      toast.success("Мэдээллийг амжилттай устгалаа", {
        autoClose: 3000,
      });

      return { id };
    } catch (error) {
      toast.error("Мэдээллийг устгахад алдаа гарлаа!", {
        autoClose: 3000,
      });

      return rejectWithValue({
        error: error.response?.data?.message || error.message,
      });
    }
  }
);

export const getWarehousesReportSummary = createAsyncThunk(
  "warehouse/getWarehousesReportSummary",
  async (filters, thunkAPI) => {
    try {
      const response = await getWarehousesReportSummaryApi(filters);
      return response;
    } catch (error) {
      console.error("Error fetching warehouse:", error);
      return thunkAPI.rejectWithValue(
        error.response || error.message || "Error fetching warehouse"
      );
    }
  }
);

export const getWarehousesReportInvoice = createAsyncThunk(
  "warehouse/getWarehousesReportInvoice",
  async (filters, thunkAPI) => {
    try {
      const response = await getWarehousesReportInvoiceApi(filters);
      return response;
    } catch (error) {
      console.error("Error fetching warehouse:", error);
      return thunkAPI.rejectWithValue(
        error.response || error.message || "Error fetching warehouse"
      );
    }
  }
);

export const getWarehousesInvoices = createAsyncThunk(
  "warehouse/getWarehousesInvoices",
  async () => {
    try {
      const response = await getWarehousesInvoicesApi();
      return response;
    } catch (error) {
      return error;
    }
  }
);

export const getWarehousesInvoiceByNumber = createAsyncThunk(
  "warehouse/getWarehousesInvoiceByNumber",
  async (invoice) => {
    try {
      const response = await getWarehousesInvoiceByNumberApi(invoice);
      return response;
    } catch (error) {
      return error;
    }
  }
);

export const addNewWarehousesInvoice = createAsyncThunk(
  "warehouse/addNewWarehousesInvoice",
  async (invoice) => {
    try {
      const response = addNewWarehousesInvoiceApi(invoice);
      toast.success("Нэхэмжлэхийг амжилттай бүртгэлээ", {
        autoClose: 3000,
      });
      return response;
    } catch (error) {
      toast.error("Нэхэмжлэхийг бүртгэхэд алдаа гарлаа!", {
        autoClose: 3000,
      });
      return error;
    }
  }
);

export const updateWarehousesInvoice = createAsyncThunk(
  "warehouse/updateWarehousesInvoice",
  async (invoice) => {
    try {
      const response = updateWarehousesInvoiceApi(invoice);
      toast.success("Нэхэмжлэхийг амжилттай засварлалаа", {
        autoClose: 3000,
      });
      return response;
    } catch (error) {
      toast.error("Нэхэмжлэхийг засварлахад алдаа гарлаа!", {
        autoClose: 3000,
      });
      return error;
    }
  }
);

export const deleteWarehousesInvoice = createAsyncThunk(
  "warehouse/deleteWarehousesInvoice",
  async (id, { rejectWithValue }) => {
    try {
      await deleteWarehousesInvoiceApi(id);

      toast.success("Нэхэмжлэхийг амжилттай устгалаа", {
        autoClose: 3000,
      });

      return { id };
    } catch (error) {
      toast.error("Нэхэмжлэхийг устгахад алдаа гарлаа!", {
        autoClose: 3000,
      });

      return rejectWithValue({
        error: error.response?.data?.message || error.message,
      });
    }
  }
);
